import React from 'react';

import { Button as BaseButton } from '../../components';
import { styled } from '../../theme';

const StyledButton = styled(BaseButton)<Props>(({ theme, selected }) => ({
    cursor: selected ? 'default' : 'pointer',
    pointerEvents: selected ? 'none' : 'auto',
    borderRadius: theme.borderRadius.base,

    ...(selected && {
        background: theme.gradients.green1,
        color: theme.color.white,
    }),

    ':hover': {
        background: theme.gradients.green1,
        color: theme.color.white,
    },

    height: 50,
}));

type Props = {
    value: any;
    label: string;
    handleClick: (value: any) => void;
    isSelected?: boolean;
};

const Button: React.FC<Props> = ({ value, label, handleClick, isSelected, ...props }) => (
    <StyledButton
        onClick={(ev) => {
            ev.preventDefault();
            handleClick(value);
        }}
        color="tertiary"
        selected={isSelected}
        {...props}
    >
        {label}
    </StyledButton>
);

export default Button;
